import HBModal from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import { openUdesk } from "@/utils/initUdesk";
import { Button, ButtonProps } from "antd";
import HBIcon from "../HBIcon";
import styles from "./alert.module.less";

type HBAlertProps = {
  content?: any;
  title?: any;
  onOk?: () => void;
  okType?: string;
  okText?: string;
  okButtonProps?: ButtonProps;
  onCancel?: () => void;
  type?: string;
  hideOkBtn?: boolean;
  hideLeftBtn?: boolean;
};

function RawHBAlert({
  content,
  title,
  onOk,
  okType,
  okText,
  okButtonProps,
  hideOkBtn = false,
  hideLeftBtn = false,
  ...props
}: HBAlertProps) {
  return (
    <HBModal {...props} footer={null} title={null} width={400}>
      <div className={styles.title}>
        <HBIcon type="ic_info" />
        {title}
      </div>
      <div className={styles.content}>{content}</div>
      <div className={styles.footer}>
        {!hideLeftBtn && (
          <a
            className={styles.concatBtn}
            onClick={() => {
              openUdesk();
            }}
          >
            联系客服
          </a>
        )}
        {!hideOkBtn && (
          <Button
            type="primary"
            className={styles.okBtn}
            onClick={() => {
              onOk && onOk();
            }}
          >
            {okText || "我知道了"}
          </Button>
        )}
      </div>
    </HBModal>
  );
}

const HBAlert = ModalWrap(RawHBAlert);
export default HBAlert;
